export function toTimeMicros(date: Date): number {
  return date.getTime() * 1000;
}
